import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { Loader } from '../../components/loader/Loader';
import { useAssetClass } from '../../contexts/assetClass';
import { useAuth } from '../../contexts/auth';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { useTranslation } from '../../contexts/translation';
import { TasksTemplateUpdateForm } from '../../forms/tasks/TasksTemplateUpdateForm';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { DetailPageParams } from '../../types/pageParams.types';
import { API_URL, fetcher } from '../../utils/apiUrl';
import { swrConfig } from '../Assets/AssetsEdit';

export function TaskTemplateEdit() {
  const { translate } = useTranslation();
  const { id } = useParams<DetailPageParams>();
  const { setValue } = useBreadcrumbs();
  const { user } = useAuth();
  const { assetClass } = useAssetClass();

  // Šalbona
  const { data: taskTemplate, isValidating } = useSWR<any>(
    `${API_URL.TASK_TEMPLATE_ITEM}?id=${id}`,
    fetcher,
    swrConfig,
  );

  const { data: asset } = useSWR<any>(
    taskTemplate ? `${API_URL.ASSET_ITEM}?id=${taskTemplate.assetId}` : null,
    fetcher,
    swrConfig,
  );

  useEffect(() => {
    setValue({
      pageName: 'Edit parameter',
      steps: [
        { name: 'Home', pathToCutCount: 3 },
        { name: 'Task templates', pathToCutCount: 2 },
      ],
    });
    return () => {
      setValue(null);
    };
  }, []);

  if (!taskTemplate || !user || isValidating) return <Loader />;
  if (taskTemplate.assetId && !asset) return <Loader />;

  return (
    <PageContentWrapper
      heading={translate!('Template detail', 'TaskTemplates.Edit')}
      loading={false}
      error={false}
    >
      <TasksTemplateUpdateForm
        defaultValues={{
          id: taskTemplate.id,
          userId: user.personalNumber,
          assetClassId: assetClass,

          inboxEmail: taskTemplate.inboxEmail,
          inboxFolderName: taskTemplate.inboxFolderName,
          requestorName: taskTemplate.requestorName,
          requestorEmail: taskTemplate.requestorEmail,
          requestorPhone: taskTemplate.requestorPhone,

          customerId: taskTemplate.customerId,
          customerProjectId: taskTemplate.customerProjectId,
          typeId: taskTemplate.typeId,
          topLevelAssetId: asset ? asset.topLevelParenId : null,
          assetId: taskTemplate.assetId,
          capacityCategoryId: taskTemplate.capacityCategoryId,
          responsiblePersonId: taskTemplate.responsiblePersonId,
        }}
      />
    </PageContentWrapper>
  );
}
